import { Link } from 'react-router-dom';
import exploreIcon from '../../../utils/icons/explore-icon.png';
// import ticketBg1 from '../../../utils/images/card-bg1.png';
// import ticketBg2 from '../../../utils/images/card-bg2.png';
// import ticketBg3 from '../../../utils/images/card-bg3.png';

const TicketSection = () => {
  const tickets = [
    {
      id: 1,
      title: "Ticket of One (1)",
      price: "10,500",
      details: [
        "ENJOY 10% DISCOUNT FOR EARLY BIRD",
        "ACCESS THE CONFERENCE",
        "NETWORKING",
        "FREE MEAL TICKET",
      ],
    },
    {
      id: 2,
      title: "Ticket of Three (3)",
      price: "26,775",
      details: [
        "ENJOY 15% DISCOUNT WITH FRIENDS",
        "ACCESS THE CONFERENCE",
        "NETWORKING",
        "FREE MEAL TICKET",
      ],
    },
    {
      id: 3,
      title: "Ticket of Five (5)",
      price: "42,000",
      details: [
        "ENJOY 20% DISCOUNT WITH FRIENDS",
        "ACCESS THE CONFERENCE",
        "NETWORKING",
        "FREE MEAL TICKET",
      ],
    },
    // Add more tickets here if needed
  ];

  return (
    <section className='ticket-section page-width px-3 my-5 py-5 d-none'>
      <h2 className="text-center text-uppercase py-5 mt-5">GET TICKETS NOW</h2>

      <section className="row justify-content-center mb-0 mb-md-5 pb-0 pb-md-5">
        {tickets.map((ticket, index) => (
          <div className="col-md-6 col-sm-12 mb-5 js-scroll fade-in-bottom" key={ticket.id}>
            <div className={`container ticket-card ticket-card${ticket.id} p-md-5 p-4 py-5`}>
              <div className="ticket-details">
                <h2 className='mb-0'>{ticket.title}</h2>
                {ticket.details.map((detail, i) => (
                  <p key={i} className='mb-0'>{detail}</p>
                ))}
              </div>
              <div className="ticket-price d-flex gap-3 justify-content-between align-items-center mt-4 mt-md-5">
                <div className='d-flex gap-1 align-items-center text-black'>
                  <p className='mb-0 custom-cosmos_medium'>N</p>
                  <h2 className='mb-0'>{ticket.price}</h2>
                </div>
                <a href='https://lu.ma/6pj6tk23' rel="noopener noreferrer"  target='_blank' className='customBtn-colored'>
                  <span>GET TICKET</span> 
                  <img src={exploreIcon} alt="explore" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </section>
    </section>
  );
};

export default TicketSection;
